import { LabelsModeled } from '../types/LabelsModeled';
import { Constants } from './../constants';
import { BannerLabels } from './../types/BannerLabels';
import { getLabelsByLanguage } from './getLabelsByLanguage';

export const getLabelsToBanner = (language: string, labels: LabelsModeled[]): BannerLabels => {
  const labelsCurrentLanguage = getLabelsByLanguage(language, labels);
  const labelsDefaultLanguage = getLabelsByLanguage(Constants.DEFAULT_LANGUAGE_CODE, labels);
  const defaultLabels = labelsDefaultLanguage?.[Constants.DEFAULT_LANGUAGE_CODE];
  const currentLabels = labelsCurrentLanguage?.[language];

  const close: string = currentLabels?.['close'] || defaultLabels?.['close'];
  const consentChanged: string = currentLabels?.['consent_changed'] || defaultLabels?.['consent_changed'];
  const hideDetails: string = currentLabels?.['hideDetails'] || defaultLabels?.['hideDetails'];
  const selectAll: string = currentLabels?.['select_all'] || defaultLabels?.['select_all'];
  const showDetails: string = currentLabels?.['showDetails'] || defaultLabels?.['showDetails'];

  return {
    close,
    consentChanged,
    hideDetails,
    selectAll,
    showDetails,
  };
};
